// src/config/env.config.js
export const getEnvConfig = () => {
    return {
        // API Configuration
        API_URL: import.meta.env.VITE_API_URL || 'http://localhost:8000',
        API_TIMEOUT: parseInt(import.meta.env.VITE_API_TIMEOUT || '30000'),

        // Application Settings
        APP_NAME: import.meta.env.VITE_APP_NAME || 'WhimsyQuill',
        SUPPORT_EMAIL: import.meta.env.VITE_SUPPORT_EMAIL || 'support@whimsyquill.com',

        // External Services
        GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID,

        // Stripe Integration
        STRIPE_API_KEY: import.meta.env.VITE_STRIPE_API_KEY,
        FAMILY_MONTHLY_PLAN:import.meta.env.VITE_STRIPE_FAMILY_MONTHLY_PLAN,
        FAMILY_MONTHLY_PRO_PLAN:import.meta.env.VITE_STRIPE_FAMILY_MONTHLY_PRO_PLAN,
        FAMILY_YEARLY_PLAN:import.meta.env.VITE_STRIPE_FAMILY_YEARLY_PLAN,
        FAMILY_YEARLY_PRO_PLAN:import.meta.env.VITE_STRIPE_FAMILY_YEARLY_PRO_PLAN,

        // Development Tools
        ENABLE_REDUX_DEVTOOLS: import.meta.env.VITE_ENABLE_REDUX_DEVTOOLS === 'true',
        DEBUG_MODE: import.meta.env.VITE_DEBUG_MODE === 'true'
    };
};
